module.exports = __webpack_public_path__ + "static/media/wesley-tingey-min.8c0de8f0.jpg";